<template>
	<div>

	</div>
</template>

<script>
import {mapGetters} from 'vuex';

import MediaManager from "@/api/MediaManager";
import {Media} from '@/store/flux360/MediaManagerDataTypes';

export default {
	computed: {
		...mapGetters(['activeLanguage','activeRegion',"allPrefabs","languages"]),
	},
	watch: {
		async activeLanguage(to, from){
			console.log("Changing Language to " + this.activeLanguage.shortCode);

			this.$root.$i18n.locale = this.activeLanguage.shortCode;

			/*if(new URL(window.location).searchParams.get("region")){ // prevent loading of panoramas when language in url (panoramas will get loaded when tour is setup in preloadAllMedia())
				if(from != undefined){
					await this.loadPanoramasForLanguage();
				}
			}else{
				await this.loadPanoramasForLanguage();
			}

			window.dispatchEvent(new CustomEvent("languageChange"));*/
		}
	},
	methods: {
		loadPanoramasForLanguage(){
			const assetM = window.assetsManager;

			let excludeMediaIDs = [];

			this.allPrefabs.forEach((prefab) => {
				if(prefab.sphereImageID){

					let media = MediaManager.getMedia(prefab.sphereImageID);

					// Filter other webp rooms
					if(media.fileName.includes(".webp") && !prefab.name.includes("_base"))
						excludeMediaIDs.push(prefab.sphereImageID);
					
					// Filter other languages .png rooms
					this.languages.forEach(language => {				
						if(!media.fileName.includes(".webp") && this.activeLanguage.shortCode == language.shortCode && !prefab.name.includes("Empfang_" + language.shortCode + "NEW"))
							excludeMediaIDs.push(prefab.sphereImageID);
					});
				}
			});

			return new Promise((resolve, reject) => {
				MediaManager.media.forEach((media) => {
					if(media.getType() === Media.MediaType.Texture && !media.getTexture() && (excludeMediaIDs.find(id => id == media.id) == undefined)){
						const task = assetM.addTextureTask(media.id, media.getURL(), false, false);

						task.onSuccess = (task) => {
							media.setTexture(task.texture);
							if(!media.getWidth() || !media.getHeight())
								media.setSize(task.texture.getSize().width / 20, task.texture.getSize().height / 20);
						};
					}
				});
			
				assetM.onFinish = () => {
					console.log(this.activeLanguage + " Loaded!");
					resolve();
				};

				assetM.onTaskError = (error) => {
					console.error("... Loading assets failed!");
					reject(error);
				};

				assetM.load();
			});
		}
	}
}
</script>